import React from 'react'
import styled from '@emotion/styled'
import { breakpoints } from '../../constants'

import DropDown from '../generic/floatingDropdown'
import TextBox from '../generic/floatingText'
import { FlexDiv } from '../generic/Basics'
import { fontSizeSmall, fontWeightBold, grayLight20 } from '../../constants/principles'
export default ({ dealerReps, dealerRep, updateGlobalState, disabled, isDesktop, useArgoStyle }) => {
  return (
    <ContentDiv isDesktop={isDesktop} useArgoStyle={useArgoStyle}>
      <InfoDiv useArgoStyle={useArgoStyle}>
        <HeaderDiv useArgoStyle={useArgoStyle}>Dealer Rep Information</HeaderDiv>
        <StyledDiv useArgoStyle={useArgoStyle}>
          <DropDown
            label="Dealer Rep"
            disabled={disabled}
            options={dealerReps}
            valueProp="dealerRepID"
            textProp="name"
            currentValue={dealerRep}
            fullWidth={true}
            onChange={e => updateGlobalState({ dealerRepId: e.target.value })}
            useArgoStyle={useArgoStyle}></DropDown>
          {!useArgoStyle && <SpacerDiv />}
          <TextBox key={dealerRep?.dealerRepID} disabled={true} label="Dealer Rep Phone" value={dealerRep?.phone} onChange={newValue => newValue} useArgoStyle={useArgoStyle} />
        </StyledDiv>
      </InfoDiv>
    </ContentDiv>
  )
}

const ContentDiv = styled(FlexDiv)`
  padding-top: 32px;
  padding-bottom: ${p => !p.useArgoStyle && '32px'};
  ${p => !p.useArgoStyle && `border-bottom: 1px solid ${grayLight20};`}
  width: ${p => (p.isDesktop && !p.useArgoStyle ? 80 : 100)}%;
`
const InfoDiv = styled(FlexDiv)`
  align-items: stretch;
  width: ${p => (p.useArgoStyle ? '95%' : '300px')};
`
const HeaderDiv = styled.div`
  margin-bottom: 16px;
  font-weight: ${fontWeightBold};
  ${p =>
    !p.useArgoStyle
      ? `
    text-align: center;
    font-size: ${fontSizeSmall};
      `
      : `
    font-size: 18px;
    line-height: 24px;
  `}
`
const StyledDiv = styled.div`
  ${p =>
    p.useArgoStyle &&
    `
    display: flex;
    width: 100%;
    gap: 8px;
    flex-direction: column;
    
    @media (min-width: ${breakpoints.highmed}px) {
      flex-direction: row
    }
  `}
` 
const SpacerDiv = styled.div`
  padding: 8px;
`
